import {Directive, ElementRef, Input} from '@angular/core';


export class FocusDirective {
   focus: boolean;
  private element: HTMLElement;
  private hasFocused = false;

  constructor ($element: ElementRef) {
    this.element = $element.nativeElement;
  }

  ngAfterContentChecked () {
    this.giveFocus();
  }

  giveFocus () {
    if (this.focus && !this.hasFocused) {
      this.element.focus();
      this.hasFocused = true;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[focus]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'focus': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
